import React, { useCallback, useState } from "react";
import { connect } from "react-redux";

// TODO: UI button does not work with AntD Search field
// Need to fix it in TART-27214
// eslint-disable-next-line no-restricted-imports
import Button from "antd/es/button";
import { defineMessages, useIntl } from "react-intl";

import Address from "@mapmycustomers/shared/types/Address";
import { isEmptyString } from "@mapmycustomers/shared/util/stringUtils";
import { SearchField } from "@mapmycustomers/ui";

import { getLeadFinderAddress, getLeadFinderMode } from "@app/component/leadFinder/store/selectors";
import AreaSearchMode from "@app/enum/AreaSearchMode";
import { RootState } from "@app/store/rootReducer";
import useAnalytics from "@app/util/contexts/useAnalytics";

interface Props {
  address?: Address;
  mode: AreaSearchMode;
  onSearch: (value: string) => void;
  query?: string;
}

const messages = defineMessages({
  goButton: {
    id: "leadFinder.searchPopover.searchBox.goButton",
    defaultMessage: "Go",
    description: "Lead Finder search box Go button title",
  },
  placeholder: {
    id: "leadFinder.searchPopover.searchBox.placeholder",
    defaultMessage: "Enter a keyword or phrase like “Hospitals near me”",
    description: "Lead Finder search box placeholder text",
  },
});

const SearchBox = ({ address, mode, onSearch, query }: Props) => {
  const analytics = useAnalytics();
  const intl = useIntl();
  const [value, setValue] = useState<string>(query ?? "");

  const isValid = !isEmptyString(value) && (mode === AreaSearchMode.ADDRESS ? !!address : true);
  const handleSearch = useCallback(() => {
    if (isValid) {
      onSearch(value);
      analytics.clicked(["Search", "Go"]);
    }
  }, [analytics, isValid, onSearch, value]);

  return (
    <SearchField
      autoFocus
      enterButton={
        <Button disabled={!isValid} type="primary">
          {intl.formatMessage(messages.goButton)}
        </Button>
      }
      onChange={setValue}
      onSearch={handleSearch}
      placeholder={intl.formatMessage(messages.placeholder)}
      showEnterButton
      size="large"
      value={value}
    />
  );
};

const mapStateToProps = (state: RootState) => ({
  address: getLeadFinderAddress(state),
  mode: getLeadFinderMode(state),
});

export default connect(mapStateToProps)(SearchBox);
